import React from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Grid,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

// Hooks
import { useTranslation } from "@/hooks/useTranslation";

const LanguageSettings = ({ language, onLanguageChange }) => {
    const { t } = useTranslation();

    return (
        <Card sx={{ mb: 4 }}>
            <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Icon name="language" size={20} />
                    <Typography variant="h6" sx={{ ml: 1 }}>
                        {t('config.language')}
                    </Typography>
                </Box>
                
                <Divider sx={{ mb: 3 }} />
                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel id="language-select-label">
                                {t('config.languageLabel')}
                            </InputLabel>
                            <Select
                                labelId="language-select-label"
                                id="language-select"
                                value={language}
                                label={t('config.languageLabel')}
                                onChange={onLanguageChange}
                            >
                                <MenuItem value="vi">Tiếng Việt</MenuItem>
                                <MenuItem value="en">Tiếng Anh (English)</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default LanguageSettings;